import { render, staticRenderFns } from "./MercadoDestinoChipGroup.vue?vue&type=template&id=ddf93b22&scoped=true&"
import script from "./MercadoDestinoChipGroup.vue?vue&type=script&lang=js&"
export * from "./MercadoDestinoChipGroup.vue?vue&type=script&lang=js&"
import style0 from "./MercadoDestinoChipGroup.vue?vue&type=style&index=0&id=ddf93b22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf93b22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VIcon,VMenu})
